let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hE4OV")).then(() => parcelRequire('j9DVR'));